import { RoleDTO } from '@/shared/services'
import { menu as userMenu } from '@/user/containers/sidebar/menu-list'
import { menu as streamMenu } from '@/stream/containers/sidebar/menu-list'
import { menu as adminMenu } from '@/admin/containers/sidebar/menu-list'
import { menu as settingMenu } from '@/setting/container/sidebar/menu-list'


export const getPortalAvaiable = (roles: RoleDTO[] = []) => {
  if (!roles) return []

  const codeAccess = new Set<string>()
  roles.forEach((role) => role.resources?.forEach((resource) => codeAccess.add(resource.code || '')))

  const mapCodeAccess = new Map(Object.entries(codeOnPortal))

  const portals = ['']
  mapCodeAccess.forEach((values, key) => {
    if (values.some((code) => codeAccess.has(code))) {
      portals.push(key)
    }
  })

  return portals
}

/* eslint-disable */
const codeOnPortal = {
  'stream': [...streamMenu.map(item => item.code)],
  'user': [...userMenu.map(item => item.code)],
  'admin': [...adminMenu.map(item => item.code)],
  'setting':  [...settingMenu.map(item => item.code)]
}
/* eslint-enable */
